import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import BootstrapTable from "react-bootstrap-table-next";
import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  FormGroup,
  Label,
  Container,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Spinner,
} from "reactstrap";
import classnames from "classnames";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {
  AvField,
  AvForm,
} from "availity-reactstrap-validation";
import preloader from "../../helpers/preloader";
import showNotification from "../../helpers/show_notification";
import { postSubmitForm } from "../../helpers/forms_helper";

const ProductsMapToAll = (props) => {
  const [activeTab, setActiveTab] = useState("map");
  const refContainer = useRef(null)
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showConfig, setShowConfig] = useState(false);
  const [branches, setBranches] = useState([]);

  useEffect(()=>{
    loadAllProducts()
  },[])


  const columns = [
    {
        dataField: "_id",
        hidden: true,
    },
    {
        dataField: "_id",
        text: "#",
        formatter: (cell, row, rowIndex) => {
            return rowIndex + 1
        },
        headerStyle: (colum, colIndex) => {
            return { width: "5%" };
          },
    },
    {
      dataField: "name",
      text: "Branch Name",
      sort: true,
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (cell,row) => {        
        return (
        <div>
          <i
            className={`bx ${
              row.is_mapped 
                ? "bx-check-circle text-success"
                : "bx-x-circle text-danger"
            } font-size-16 align-middle`}
          ></i>
          {/* <span className="ms-2">{cell}</span> */}
        </div>
      )},
    },
  ];


  const handleProductSelect = (selected) => {
    setSelectedProduct(selected);
  };

  const [allProducts, setAllProducts] = useState([]);
  const [catalogLoading, setCatalogLoading] = useState(true);
  const loadAllProducts = async () => {
    try {
      setCatalogLoading(true);
      let url = process.env.REACT_APP_BASEURL + "products/getall";
    let response = await postSubmitForm(url, { catalog_only: true });
    if (response.status === 1) {
      setAllProducts(response.data);
    } else {
      showNotification(response.message, "error")
    }
    } catch (error) {
      console.log(error);
      
    } finally {
      setCatalogLoading(false);
    }
  };

  const handleMapping = async (type) => {
    try {
      preloader(true);
      setShowConfig(true)
      let endpoint = type === "mapping" ? "branchproducts/get_unmapped" : "branchproducts/get_mapped";
      let url = process.env.REACT_APP_BASEURL + endpoint;
      let response = await postSubmitForm(url, {product_id: selectedProduct.value});
      if (response.status === 1) {
        const updated = response.data.map(item => ({ ...item, is_mapped: true })).sort((a, b) => a.name.localeCompare(b.name));;
        // refContainer.current.reset();
        setBranches(updated);
      }
    } catch (error) {
      console.log(error);
    } finally {
      preloader(false);
    }
  };

  const handleSubmit = async (type,e,v) => {
    try {
      setIsSubmitting(true);
      let endpoint = type === "mapping" ? "branchproducts/map_branches" : "branchproducts/unmap_branches";
      let payload = {
        product_id: selectedProduct.value,
        // branch_ids: branches.map(branch => ({branch_id: branch._id})),
        branch_ids: branches.filter(branch=>branch.is_mapped).map(branch => branch._id),
      };
      if(type === "mapping") {
        Object.assign(payload,{
          threshold: +v.threshold, 
          max_order_limit: +v.max_order_limit, 
          max_order_limit_weekly: +v.max_order_limit_weekly
        })
      };
  
      let url = process.env.REACT_APP_BASEURL + endpoint;
      let response = await postSubmitForm(url, payload);
      if (response.status === 1) {
        showNotification(response.message, "Success");
        if(type==="mapping"){
          refContainer.current.reset();
        }
        setBranches([])
        setSelectedProduct(null);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setSelectedProduct(null);
      setBranches([]);
    }
  };

  const selectRow = {
    mode: 'checkbox',
    clickToSelect: true,
    selected: branches.filter(item => item.is_mapped).map(item => item._id),
    onSelect: (row, isSelect) => {
        setBranches(prevData => 
          prevData.map(item => 
            item._id === row._id 
              ? { ...item, is_mapped: isSelect }
              : item
          )
        );
      },
    onSelectAll: (isSelect, rows) => {
        setBranches(prevData =>
          prevData.map(item => ({ ...item, is_mapped: isSelect }))
        );
        if (isSelect) {
          return rows.map(row => row._id);
        }
        return [];
      },
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={props.t("Product - Branches Mapping/Unmapping")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <Nav tabs className="nav-tabs-custom">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "map" })}
                        onClick={() => toggleTab("map")}
                      >
                        {props.t("Map Products")}
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: activeTab === "unmap",
                        })}
                        onClick={() => toggleTab("unmap")}
                      >
                        {props.t("Unmap Products")}
                      </NavLink>
                    </NavItem>
                  </Nav>

                  <TabContent activeTab={activeTab} className="p-3">
                    <TabPane tabId="map">
                        <Row>
                          <Col md={6}>
                            <FormGroup>
                              <Label>{props.t("Select Product to Map")}</Label>
                              <Select
                                options={allProducts}
                                value={selectedProduct}
                                onChange={handleProductSelect}
                                isLoading={catalogLoading}
                                classNamePrefix="select2-selection"
                              />
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <Button
                              color="success"
                              className="mt-4"
                              onClick={()=>handleMapping("mapping")}
                            >
                              <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                              {props.t("Map To All")}
                            </Button>
                          </Col>
                        </Row>

                        {showConfig && (
                          <>
                            <AvForm
                              onValidSubmit={(e,v)=>handleSubmit("mapping",e,v)}
                              className="mt-4"
                              ref={refContainer}
                            >
                             {selectedProduct && (
                               <Row>

                               <Col md={2}>
                                 <AvField
                                   name="max_order_limit"
                                   defaultValue="0"
                                   label={props.t(`Max Order Limit (${selectedProduct?.unit_for_max_order})`)}
                                   placeholder={props.t(
                                     "Enter Max Order Limit"
                                   )}
                                   type="number"
                                   validate={{
                                     required: {
                                       value: true,
                                       errorMessage: props.t(
                                         "Max Order Limit cannot be empty."
                                       ),
                                     },
                                     pattern: {
                                       value: "^[0-9]+$",
                                       errorMessage: props.t(
                                         "Only numbers are allowed."
                                       ),
                                     },
                                   }}
                                 />
                               </Col>

                               <Col md={2} hidden={!selectedProduct?.is_premium_product}>
                                 <AvField
                                   name="max_order_limit_weekly"
                                   label={props.t(`Weekly Order Limit (${selectedProduct?.unit_for_max_order})`)}
                                   defaultValue="0"
                                   placeholder={props.t(
                                     "Enter Weekly Order Limit"
                                   )}
                                   type="number"
                                   validate={{
                                     required: {
                                       value: true,
                                       errorMessage: props.t(
                                         "Weekly Order Limit cannot be empty."
                                       ),
                                     },
                                     pattern: {
                                       value: "^[0-9]+$",
                                       errorMessage: props.t(
                                         "Only numbers are allowed."
                                       ),
                                     },
                                   }}
                                 />
                               </Col>

                               <Col lg={2}>
                                 <AvField
                                   name="threshold"
                                   label={props.t(`Threshold Qty (${selectedProduct?.unit_for_max_order})` )}
                                   defaultValue="0"
                                   placeholder={props.t(
                                     "Enter Threshold Quantity"
                                   )}
                                   type="number"
                                   validate={{
                                     required: {
                                       value: true,
                                       errorMessage: props.t(
                                         "Threshold cannot be empty."
                                       ),
                                     },
                                     pattern: {
                                       value: "^[0-9]+$",
                                       errorMessage: props.t(
                                         "Only numbers are allowed."
                                       ),
                                     },
                                   }}
                                 />
                               </Col>

                             </Row>
                             )}
                            <BootstrapTable
                              keyField="_id"
                              data={branches}
                              columns={columns}
                              selectRow={ selectRow }
                              noDataIndication="No data to display."
                              striped
                              hover
                              condensed
                            />

                            <div className="d-flex justify-content-center mt-3">
                              <Button color="primary" type="submit" style={{width: "100px"}} disabled={isSubmitting}>
                                {isSubmitting ? <Spinner size="sm"/> : props.t("Submit")}
                              </Button>
                            </div>
                            </AvForm>

                          </>
                        )}
                    </TabPane>

                    {/* Unmapp  */}
                    <TabPane tabId="unmap">
                    <Row>
                          <Col md={6}>
                            <FormGroup>
                              <Label>{props.t("Select Product to Unmap")}</Label>
                              <Select
                                options={allProducts}
                                value={selectedProduct}
                                onChange={handleProductSelect}
                                isLoading={catalogLoading}
                                classNamePrefix="select2-selection"
                              />
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <Button
                              color="success"
                              className="mt-4"
                              onClick={()=>handleMapping("unmapping")}
                            >
                              <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                              {props.t("Unmap To All")}
                            </Button>
                          </Col>
                        </Row>

                        {showConfig && (
                          <>
                            <AvForm
                              onValidSubmit={()=>handleSubmit("unmapping")}
                              className="mt-4"
                            >
                            <BootstrapTable
                              keyField="_id"
                              data={branches}
                              columns={columns}
                              selectRow={ selectRow }
                              noDataIndication="No data to display."
                              striped
                              hover
                              condensed
                            />

                            <div className="d-flex justify-content-center mt-3">
                            <Button color="primary" type="submit" style={{width: "100px"}} disabled={isSubmitting}>
                                {isSubmitting ? <Spinner size="sm"/> : props.t("Submit")}
                              </Button>
                            </div>
                            </AvForm>

                          </>
                        )}
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(connect(null, {})(withNamespaces()(ProductsMapToAll)));
